import { initialOrderState } from 'redux/initialState';
import { status } from 'constants/general';

import orderActionTypes from './action-types';

const orderReducer = (state = initialOrderState, { type, payload }) => {
  switch (type) {
    case orderActionTypes.FETCH_GET_USER_ADDRESS: {
      return {
        ...state,
        getAddressInfo: {
          status: status.FETCHING,
        },
      };
    }

    case orderActionTypes.FETCH_GET_USER_ADDRESS_SUCCESS: {
      return {
        ...state,
        getAddressInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };
    }

    case orderActionTypes.FETCH_GET_USER_ADDRESS_FAIL: {
      return {
        ...state,
        getAddressInfo: {
          status: status.FAIL,
        },
      };
    }

    case orderActionTypes.FETCH_ADD_USER_ADDRESS: {
      return {
        ...state,
        addAddressInfo: {
          status: status.FETCHING,
        },
      };
    }

    case orderActionTypes.FETCH_ADD_USER_ADDRESS_SUCCESS: {
      return {
        ...state,
        addAddressInfo: {
          status: status.SUCCESS,
        },
      };
    }

    case orderActionTypes.FETCH_ADD_USER_ADDRESS_FAIL: {
      return {
        ...state,
        addAddressInfo: {
          status: status.FAIL,
        },
      };
    }

    case orderActionTypes.FETCH_SEARCH_PRODUCTS: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.FETCHING,
        },
      };
    }

    case orderActionTypes.FETCH_SEARCH_PRODUCTS_SUCCESS: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };
    }

    case orderActionTypes.FETCH_SEARCH_PRODUCTS_FAIL: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.FAIL,
        },
      };
    }

    case orderActionTypes.RESET_SEARCH_PRODUCTS: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.SHOULD_CALL_API,
        },
      };
    }

    case orderActionTypes.FETCH_SUBMIT_ORDER_BULK: {
      return {
        ...state,
        submitOrderBulkInfo: {
          status: status.FETCHING,
        },
      };
    }

    case orderActionTypes.FETCH_SUBMIT_ORDER_BULK_SUCCESS: {
      return {
        ...state,
        submitOrderBulkInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };
    }

    case orderActionTypes.FETCH_SUBMIT_ORDER_BULK_FAIL: {
      return {
        ...state,
        submitOrderBulkInfo: {
          status: status.FAIL,
        },
      };
    }

    default:
      return state;
  }
};

export default orderReducer;
